export const chevronMoveDirectionOptions = {
  UP_TO_DOWN: 'upToDown',
  RIGHT_TO_DOWN: 'rightToDown'
}
